export function setWithExpiry(key, value, ttl=3600000) {
  const now = new Date();

  const item = {
    value: value,
    expiry: now.getTime() + ttl // ttl is in milliseconds
  };

  localStorage.setItem(key, JSON.stringify(item));
}

export function getWithExpiry(key) {
  // localStorage.removeItem(key);
  // return
  const itemStr = localStorage.getItem(key);

  if (!itemStr) {
    return null;
  }

  try {
    const item = JSON.parse(itemStr);

    if (new Date().getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  } catch (err) {
    console.error("Failed to parse localStorage item:", err);
    return null;
  }
}
